'use client'

import { createContext } from 'react'
import type { Customer, Organization } from '@leid/api-customers'

export type CustomerInfo = {
  customer: Customer | undefined
  organization: Organization | undefined
}

export type AuthenticatedCustomerInfoContext = {
  isLoading: boolean
  customerInfo: CustomerInfo
  selectOrganizationOrPersonalAccount: (organizationId: number | undefined) => Promise<boolean>
  signIn: () => Promise<boolean>
  signOut: () => Promise<void>
}

const CustomerInfoContext = createContext<AuthenticatedCustomerInfoContext>({
  isLoading: true,
  customerInfo: {
    customer: undefined,
    organization: undefined,
  },
} as AuthenticatedCustomerInfoContext)

export default CustomerInfoContext
